import {FETCH_BUILD_ERROR, FETCH_BUILD_PENDING, FETCH_BUILD_SUCCESS} from './actions';

const initialState = {
  data: {},
  error: null,
  loading: false,
  fetched: false,
};

export const buildReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BUILD_PENDING:
      return {
        data: {},
        error: null,
        loading: true,
        fetched: true,
      };
    case FETCH_BUILD_SUCCESS:
      return {
        data: action.payload,
        error: null,
        loading: false,
        fetched: true,
      };
    case FETCH_BUILD_ERROR:
      return {
        data: {},
        error: action.error,
        loading: false,
        fetched: true,
      };
    default:
      return state;
  }
};
